import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import CoreModal from 'shared/CoreModal';
import styled from 'styled-components';
import { PlatformCode } from 'type/common';
import ReportLayout from './report-layout/ReportLayout';
import InstagramContainer from './container/ig/InstagramContainer';
import YoutubeContainer from './container/yt/YoutubeContainer';
import TiktokContainer from './container/tt/TiktokContainer';
import NaverBlogContainer from './container/nb/NaverBlogContainer';

const ReportModal = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [search_params] = useSearchParams();
	const platformCode = search_params.get('p') as PlatformCode;

	const setModal = (value: boolean) => {
		if (value === true) return;

		const params = new URLSearchParams(location.search);
		params.delete('rm');
		params.delete('pk');
		params.delete('p');
		navigate({ search: params.toString() });
	};

	return (
		<>
			<CoreModal
				modal_type="common"
				top={40}
				left={`calc(50% - 512px)`}
				radius={16}
				bg_colored={true}
				setModal={setModal}
			>
				<ReportLayout setModal={setModal}>
					<>
						{platformCode === 'ig' && <InstagramContainer />}
						{platformCode === 'yt' && <YoutubeContainer />}
						{platformCode === 'tt' && <TiktokContainer />}
						{platformCode === 'nb' && <NaverBlogContainer />}
					</>
				</ReportLayout>
			</CoreModal>
		</>
	);
};

export default ReportModal;
